import { usePlanningStore } from "@/stores/planning";

// WATCHERS THAT LAUNCH ACTIONS FROM planning STATE CHANGES


export const init_planning_watchers = function () {
    const planning_store = usePlanningStore()

    planning_store.$subscribe((mutation, state) => {
        if (["hover_row", "hover_cell"].includes(mutation?.events?.key)) return
        console.log("🍍👁️ Empty watchers for planning store.")
    })
}